import React from "react";

import { ACTIVE_BACK_OFFICE_LOGO_VARIANT, DEFAULT_MARK_SIZE } from "../consts";
import { BackOfficeLogoMarkProps } from "../types";
import ApexMark from "./ApexMark";
import LedgerMark from "./LedgerMark";
import MomentumMark from "./MomentumMark";
import SignalMark from "./SignalMark";

/** The logo artwork on its own, without the wordmark beside it. */
const BackOfficeLogoMark = ({
  size = DEFAULT_MARK_SIZE,
  variant = ACTIVE_BACK_OFFICE_LOGO_VARIANT,
  ...rest
}: BackOfficeLogoMarkProps) => {
  switch (variant) {
    case "apex":
      return <ApexMark size={size} {...rest} />;
    case "signal":
      return <SignalMark size={size} {...rest} />;
    case "ledger":
      return <LedgerMark size={size} {...rest} />;
    case "momentum":
    default:
      return <MomentumMark size={size} {...rest} />;
  }
};

export default BackOfficeLogoMark;
